import { useCallback, useState } from "react";
import { toRange } from '@thebouqs/utils';
export var useCarousel = function useCarousel(slides, span, initialSlide) {
  var _slides$length, _span;

  if (span === void 0) {
    span = 1;
  }

  if (initialSlide === void 0) {
    initialSlide = 0;
  }

  // elements and translation will be updated for index and offset changes
  var [position, setPosition] = useState(initialSlide);
  var length = (_slides$length = slides == null ? void 0 : slides.length) != null ? _slides$length : 0;
  var spanAdjustment = ((_span = span) != null ? _span : 1) - 1;
  var goTo = useCallback(dest => {
    setPosition(toRange(dest, length - spanAdjustment));
  }, [length, spanAdjustment]);
  var jump = useCallback(num => {
    setPosition(toRange(position + num, length - spanAdjustment));
  }, [length, position, spanAdjustment]);
  return {
    goTo,
    jump,
    position
  };
};
//# sourceMappingURL=useCarousel.js.map